var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./InputNumber.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1785800c\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./InputNumber.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/InputNumber/InputNumber.vue.html
// module id = fgYM
// module chunks = 2